// src/services/intakeApi.js

// ---- Config ----
const BASE_URL = "https://api.physica.fit" || "";
const API_PREFIX = "/api/v1";
const INTAKE_PREFIX = "/intakeForm";

// Build full URL like: http://52.220.255.148:4000/api/v1/intakeForm/start
const url = (path) => `${BASE_URL}${API_PREFIX}${INTAKE_PREFIX}${path}`;

// ---- Helpers ----
const toJson = async (res) => {
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try {
      const err = await res.json();
      if (err?.message) msg = err.message;
    } catch {}
    throw new Error(msg);
  }
  return res.json();
};

/**
 * POST utility that can handle both JSON and FormData uploads
 */
const post = (path, body, isFormData = false) => {
  const options = {
    method: "POST",
    // Only set headers for JSON, browser handles FormData headers automatically
    headers: isFormData ? {} : { "Content-Type": "application/json" },
    body: isFormData ? body : JSON.stringify(body),
  };
  return fetch(url(path), options).then(toJson);
};

// ---- Public API ----

/** POST /api/v1/intakeForm/start */
export const startIntake = ({ phone_number, form_type, name, city, user_id = null }) =>
  post("/start", { phone_number, form_type, name, city, user_id });

/** POST /api/v1/intakeForm/save 
 * Supports both JSON and FormData uploads
 */
export const saveAnswer = (payload, isFormData = false) => post("/save", payload, isFormData);

/** POST /api/v1/intakeForm/submit */
export const submitIntake = ({ uid }) => post("/submit", { uid });

export default { startIntake, saveAnswer, submitIntake };
